import { PhotoForm } from '@/components/PhotoForm';
import { Photo } from '@/lib/Photo';
import { PhotoData } from '@/types';

export const UploadPhotoPane = () => {
  const photoData: PhotoData = {
    id: '',
    title: '',
    description: '',
    type: '',
    image_url: '',
    date: new Date(),
    updated_at: new Date().toISOString(),
    user_id: '',
  };

  const photo = new Photo(photoData);

  return (
    <div className="w-full h-full">
      <PhotoForm photo={photo} />
    </div>
  );
};
